import { AbsenceFilter, AbsencePagination, AbsenceRecord, CreateAbsenceData, ReviewAbsenceData, UpdateAbsenceData } from '../../types';
import apiClient from '../apiClient';

class AbsenceService {
    async getAbsencesPaginated(filter: AbsenceFilter) {
        return (
            await apiClient.post<AbsencePagination>('/api/attendance/absences/filter', {
                ...filter,
                page: filter?.page ?? 1,
                perPage: filter?.perPage ?? 20,
            })
        ).data;
    }

    async getAbsenceById(id: number) {
        return (await apiClient.get<AbsenceRecord>(`/api/attendance/absences/${id}`)).data;
    }

    async createAbsence(data: CreateAbsenceData) {
        return (await apiClient.post<AbsenceRecord>('/api/attendance/absences', data)).data;
    }

    async updateAbsence(id: number, data: UpdateAbsenceData) {
        return (await apiClient.put<AbsenceRecord>(`/api/attendance/absences/${id}`, data)).data;
    }

    async cancelAbsence(id: number) {
        return (await apiClient.delete<void>(`/api/attendance/absences/${id}`)).data;
    }

    async reviewAbsence(id: number, data: ReviewAbsenceData) {
        return (await apiClient.put<AbsenceRecord>(`/api/attendance/absences/${id}/review`, data)).data;
    }
}

export default new AbsenceService();
